// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".case-summary-item{margin-bottom:12px}.case-summary-item__media-container{display:flex;align-items:flex-start}.case-summary-item__media-left{margin-right:8px}.case-summary-item__media-body{flex:1}.case-summary-item__media-heading{margin:5px 0 2px 0}.case-summary-item__subhead{margin-top:0}", ""]);
// Exports
module.exports = exports;
